import { render } from "./eb-toggle.vue?vue&type=template&id=5ba8baf8"
import script from "./eb-toggle.vue?vue&type=script&lang=ts"
export * from "./eb-toggle.vue?vue&type=script&lang=ts"
script.render = render

export default script